import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type CrmSearchRecordType = 'lead' | 'applicant';

export type CrmSearchResultItem = {
  recordType: CrmSearchRecordType;
  id: string;
  fullName: string;
  email?: string;
  phoneNumber: string;
  statusName: string;
  statusCode: string;
};

type CrmSearchResponse = {
  items: CrmSearchResultItem[];
};

export type CrmSearchArea = 'platform' | 'tenant';

@Injectable({ providedIn: 'root' })
export class CrmSearchService {
  constructor(private readonly api: ApiService) {}

  search(area: CrmSearchArea, query: string) {
    const q = query.trim();
    const prefix = area === 'tenant' ? 'tenant/crm/search' : 'platform/crm/search';
    const params = new URLSearchParams({ q });
    return this.api
      .get<ApiEnvelope<CrmSearchResponse>>(`${prefix}?${params}`)
      .pipe(map((response) => response.data.items));
  }
}
